var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF88"
    },
    d: "M256,478.3c0,4.8-3.2,8.8-8,8.8l0,0c-4.8,0-8-4-8-8.8V341.5c0-4.8,3.2-8.8,8-8.8l0,0c4.8,0,8,4,8,8.8 V478.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFFCC"
    },
    d: "M496,239.9c0,4.8-3.2,8-8,8H352c-4.8,0-8-3.2-8-8l0,0c0-4.8,3.2-8,8-8h136 C492.8,231.9,496,235.1,496,239.9L496,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF44"
    },
    d: "M152,239.9c0,4.8-3.2,8-8,8H8c-4.8,0-8-3.2-8-8l0,0c0-4.8,3.2-8,8-8h136 C148.8,231.9,152,235.1,152,239.9L152,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFFEE"
    },
    d: "M326.4,172.7c-3.2,3.2-8.8,3.2-12,0l0,0c-3.2-3.2-3.2-8.8,0-12l96.8-96.8c3.2-3.2,8.8-3.2,12,0l0,0 c3.2,3.2,3.2,8.8,0,12L326.4,172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF66"
    },
    d: "M84.8,414.3c-3.2,3.2-8.8,3.2-12,0l0,0c-3.2-3.2-3.2-8.8,0-12l96.8-96.8c3.2-3.2,8.8-3.2,12,0l0,0 c3.2,3.2,3.2,8.8,0,12L84.8,414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFFAA"
    },
    d: "M314.4,317.5c-3.2-3.2-3.2-8.8,0-12l0,0c3.2-3.2,8.8-3.2,12,0l96.8,96.8c3.2,3.2,3.2,8.8,0,12l0,0 c-3.2,3.2-8.8,3.2-12,0L314.4,317.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF22"
    },
    d: "M72.8,75.1c-3.2-3.2-3.2-8,0-11.2l0,0c3.2-3.2,8.8-3.2,12,0l96.8,96.8c3.2,3.2,3.2,8.8,0,12l0,0 c-3.2,3.2-8.8,3.2-12,0L72.8,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFFFF"
    },
    d: "M295.2,147.1c-2.4,4.8-7.2,6.4-11.2,4.8l0,0c-4-1.6-6.4-6.4-4.8-11.2l52-126.4 c1.6-4,6.4-6.4,11.2-4.8l0,0c4,1.6,6.4,6.4,4.8,11.2L295.2,147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF77"
    },
    d: "M164.8,463.9c-1.6,4-6.4,6.4-11.2,4.8l0,0c-4-1.6-6.4-6.4-4.8-11.2l52-126.4c1.6-4,6.4-6.4,11.2-4.8 l0,0c4,1.6,6.4,6.4,4.8,11.2L164.8,463.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFFBB"
    },
    d: "M340,285.5c-4-1.6-6.4-6.4-4.8-11.2l0,0c1.6-4,6.4-6.4,11.2-4.8l126.4,52c4,1.6,6.4,6.4,4.8,11.2l0,0 c-1.6,4-6.4,6.4-11.2,4.8L340,285.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF33"
    },
    d: "M23.2,155.1c-4-1.6-6.4-6.4-4.8-11.2l0,0c1.6-4,6.4-6.4,11.2-4.8L156,191.9c4,1.6,6.4,6.4,4.8,11.2 l0,0c-1.6,4-6.4,6.4-11.2,4.8L23.2,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFFDD"
    },
    d: "M345.6,207.1c-4,1.6-8.8,0-11.2-4.8l0,0c-1.6-4,0-9.6,4.8-11.2l126.4-52.8c4-1.6,9.6,0,11.2,4.8l0,0 c1.6,4,0,9.6-4.8,11.2L345.6,207.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF55"
    },
    d: "M30.4,339.1c-4,1.6-9.6,0-11.2-4.8l0,0c-1.6-4,0-9.6,4.8-11.2l126.4-52.8c4-1.6,8.8,0,11.2,4.8l0,0 c1.6,4,0,9.6-4.8,11.2L30.4,339.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF99"
    },
    d: "M280,336.7c-1.6-4,0-8.8,4.8-11.2l0,0c4-1.6,9.6,0,11.2,4.8l52.8,126.4c1.6,4,0,9.6-4.8,11.2l0,0 c-4,1.6-9.6,0-11.2-4.8L280,336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF11"
    },
    d: "M148,20.7c-1.6-4,0-9.6,4.8-11.2l0,0c4-1.6,9.6,0,11.2,4.8l52,126.4c1.6,4,0,9.6-4.8,11.2l0,0 c-4,1.6-9.6,0-11.2-4.8L148,20.7z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.978873e29e5ee587b5d2a73d8f70573f.svg";
export { ForwardRef as ReactComponent };